module.exports = __webpack_public_path__ + "media/components/assets/img/pic/piggybank-flyo-285f3088029ef6c6bdd969f4a16fa3f9.svg";